import { COLOR, CORNERS } from 'vars/index'

export const BorderColors = {
  TEXT_ICON_SECONDARY: COLOR.TEXT_ICON_SECONDARY,
  ACCENT_SECONDARY: COLOR.ACCENT_SECONDARY,
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
} as const
export type BorderColors = (typeof BorderColors)[keyof typeof BorderColors]

export const Background = {
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
  ACCENT_PRIMARY_GRADIENT: COLOR.ACCENT_PRIMARY_GRADIENT,
  DISABLED: COLOR.DISABLED,
} as const
export type Background = (typeof Background)[keyof typeof Background]

export const Color = {
  TEXT_BUTTON_PRIMARY: COLOR.TEXT_ICON_CONSTANT_LIGHT,
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
} as const
export type Color = (typeof Color)[keyof typeof Color]

export const Corners = {
  CORNERS_10: CORNERS.CORNERS_10,
} as const
export type Corners = (typeof Corners)[keyof typeof Corners]
